import React, { useEffect, useState } from "react";

export function ScrollProgress() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const update = () => {
      const docH = document.documentElement.scrollHeight - window.innerHeight;
      const p = docH > 0 ? window.scrollY / docH : 0;
      setProgress(Math.min(1, Math.max(0, p)));
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    return () => {
      window.removeEventListener("scroll", update);
      window.removeEventListener("resize", update);
    };
  }, []);
  return (
    <div
      aria-hidden="true"
      className="fixed top-0 left-0 right-0 h-[2px] z-[70]"
      data-testid="scroll-progress"
    >
      <div
        className="h-full"
        style={{
          width: `${progress * 100}%`,
          background:
            "linear-gradient(90deg, rgba(61,198,224,0) 0%, rgba(61,198,224,0.6) 30%, rgba(240,196,90,0.9) 70%, rgba(240,196,90,0) 100%)",
          transition: "width 120ms linear",
        }}
      />
    </div>
  );
}
